export default __webpack_public_path__ + "static/media/pests.4ff1dc51.png";